import type { RegionLocation } from '~/types/regions'
import { useRegions } from '~/composables/regions/use-regions'
import { useScrollLock } from '@vueuse/core'

// Глобальное состояние модалки (синглтон)
const isOpen = ref(false)
const modalResolve = ref<((region: RegionLocation | null) => void) | null>(null)
const modalReject = ref<((reason?: any) => void) | null>(null)

export const useRegionModal = () => {
  const {
    regions,
    displayedRegions,
    searchQuery,
    searchLoading,
    loadRegions,
    selectRegion,
    searchRegions,
    clearSearch,
  } = useRegions()

  // Инициализация scrollLock только на клиенте
  if (import.meta.client) {
    const scrollLock = useScrollLock(document.body)
    watch(isOpen, value => {
      scrollLock.value = value
    })
  }

  // Открыть модалку и получить регион (промис)
  const openRegionModal = async (): Promise<RegionLocation | null> => {
    if (regions.value.length === 0) {
      await loadRegions()
    }

    clearSearch()
    isOpen.value = true

    return new Promise((resolve, reject) => {
      modalResolve.value = resolve
      modalReject.value = reject
    })
  }

  // Закрыть модалку без выбора
  const closeModal = () => {
    isOpen.value = false
    clearSearch()
    modalResolve.value = null
    modalReject.value = null
  }

  // Выбрать регион и закрыть модалку
  const selectRegionAndClose = (region: RegionLocation | null) => {
    selectRegion(region)

    isOpen.value = false
    clearSearch()

    if (modalResolve.value) {
      modalResolve.value(region)
    }

    modalResolve.value = null
    modalReject.value = null
  }

  return {
    // Состояние
    isOpen: readonly(isOpen),
    regions: readonly(displayedRegions),
    searchQuery: readonly(searchQuery),
    searchLoading: readonly(searchLoading),

    // Методы
    openRegionModal,
    closeModal,
    selectRegionAndClose,
    searchRegions,
  }
}
